var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "item-card background",
      class: _vm.getCardStatusClass(_vm.item)
    },
    [
      _c(
        "v-card-title",
        { staticClass: "py-0 pr-0 pl-2" },
        [
          _vm._v("\n\t\t" + _vm._s(_vm.item.name) + "\n\t\t"),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "ma-0 ml-2",
              attrs: { flat: "", icon: "", small: "" },
              on: { click: _vm.remove }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "pa-0" }, [
        _vm.item.type === "image"
          ? _c(
              "div",
              [
                _c("v-img", {
                  attrs: {
                    src: _vm.generateURL(_vm.item.file),
                    height: "100px"
                  }
                })
              ],
              1
            )
          : _c(
              "div",
              { staticStyle: { "text-align": "center" } },
              [
                _c("v-icon", { attrs: { size: 98 } }, [_vm._v("file_present")]),
                _vm._v(" "),
                _vm.item.block_reasons.length
                  ? _c("span", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm._f("humanizeBytes1000")(_vm.item.file.size)
                          ) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
      ]),
      _vm._v(" "),
      _vm.item.block_reasons.length
        ? _c(
            "v-card-text",
            { staticClass: "px-1 py-0" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _vm._l(_vm.item.block_reasons, function(br, brIndex) {
                return _c("div", { key: "br_" + brIndex }, [
                  _vm._v("\n\t\t\t" + _vm._s(br) + "\n\t\t")
                ])
              }),
              _vm._v(" "),
              _c("v-spacer")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item.error
        ? _c("v-card-actions", { staticClass: "py-0" }, [
            _c("span", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: _vm.item.error,
                  expression: "item.error"
                }
              ]
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.item.block_reasons.length
        ? _c(
            "v-card-actions",
            { staticClass: "pa-0" },
            [
              _c(
                "v-progress-linear",
                {
                  attrs: {
                    height: "20",
                    color: "primary lighten-1",
                    value: _vm.item.progress
                  }
                },
                [
                  _c("span", { staticClass: "pl-1 bottom-infos" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm._f("humanizeBytes1000")(_vm.item.file.size)
                        ) +
                        "\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "float-right pr-1 bottom-infos" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(Math.floor(_vm.item.progress)) +
                        "%\n\t\t\t"
                    )
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45a34c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a34c7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/about/ticket_attachment_item.vue
// module id = null
// module chunks = 